import { useMutation, useQueryClient } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

/** Opens the read-only session; the dialog renders refusals (two-factor, suspended) itself. */
export function useStartSupportSession(organizationId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reason: string) => organizationsApi.startSupportSession(organizationId, reason),
    meta: { silentError: true },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: organizationKeys.supportSessions() }),
  });
}

/** Ends a session now; every admin tab opened on it is signed out on its next request. */
export function useEndSupportSession() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (supportSessionId: string) => organizationsApi.endSupportSession(supportSessionId),
    meta: { successMessage: 'organizations:toasts.supportSessionEnded' },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: organizationKeys.supportSessions() }),
  });
}
